import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion } from 'framer-motion';

import { setFirstLoad } from '../store/globalReducer';

export default function PageTransitionWrap({ children }) {
  const dispatch = useDispatch();
  const isFirstLoad = useSelector(state => state.global.isFirstLoad);

  useState(() => {
    setTimeout(() => {
      dispatch(setFirstLoad());
    }, 1000);
  }, []);

  return (
    <motion.div
      initial={{ opacity: isFirstLoad ? 1 : 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}>
      { children }
    </motion.div>
  )
}